import React from 'react';
import './NotFound.css';

import { Button, PageTitle } from '../../../components';
import { images } from '../../../constants';

import { FaHome } from 'react-icons/fa';



const NotFound = () => { 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Not Found'} page={'Not Found'} />

      <section className="not-found">
        <div className="box-container">

            <img src={images.notFound} alt='Not Found Imagge' /> 
            <h5><span>sorry!</span> Page Not Found</h5>
            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum quae eius delectus fugiat sint.</p>
            {/* Button to navigate back to the homepage */}
            <Button link={''} title={'Go Back Home'} icon={FaHome} />

        </div>
      </section>
    </> 
  );
}

export default NotFound;